var map = {
	"./aep.png": 78806,
	"./ai.png": 4970,
	"./ar.png": 45494,
	"./canva.png": 28659,
	"./csv.png": 97922,
	"./default.png": 43152,
	"./doc.png": 63710,
	"./docx.png": 55890,
	"./eot.png": 51883,
	"./eps.png": 53765,
	"./fig.png": 99555,
	"./figma.png": 56370,
	"./gif.png": 81724,
	"./google_slides.png": 51678,
	"./heic.png": 60742,
	"./id.png": 65293,
	"./indd.png": 18797,
	"./indl.png": 23898,
	"./jpeg.png": 55369,
	"./jpg.png": 25345,
	"./key.png": 53251,
	"./mogrt.png": 82478,
	"./mov.png": 71257,
	"./mp4.png": 47144,
	"./otf.png": 37977,
	"./pdf.png": 38073,
	"./pdfx.png": 83161,
	"./png.png": 55915,
	"./pp.png": 79627,
	"./ppt.png": 35334,
	"./pptx.png": 1179,
	"./ps.png": 92157,
	"./psd.png": 3163,
	"./rar.png": 30152,
	"./slides.png": 7883,
	"./svg.png": 94086,
	"./ttf.png": 91254,
	"./txt.png": 38567,
	"./video-preview.png": 20337,
	"./video.png": 30249,
	"./woff.png": 70273,
	"./xls.png": 87994,
	"./xlsx.png": 22717,
	"./zip.png": 85193
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58390;